export default __webpack_public_path__ + "static/media/location.e4711113.png";